<template>
  <main role="main">
    <b-container class="py-5" style="max-width:400px;">
      <h4 class="mb-3 text-center">{{ $t("forgotPassword") }}</h4>
      <b-form class="mb-3" @submit.prevent="onSubmit" v-if="!successMsg">
        <!-- <div class="form-group">
          <label for="input-username">Username</label>
          <div class="input-group mb-3">
            <input id="input-username" type="text" class="form-control" v-model="username" required>
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-user"></span>
              </div>
            </div>
          </div>
        </div> -->
        <div class="form-group">
          <label for="input-email">Email</label>
          <div class="input-group mb-3">
            <input id="input-email" type="text" class="form-control" v-model="email" required>
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-envelope"></span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="errorMsg" class="text-danger">{{ $t(errorMsg) }}</div>
        <div class="text-center pt-3">
          <button type="submit" class="btn btn-primary btn-block" :disabled="isLoading">{{ $t("actionComplete") }}</button>
        </div>

        <div class="text-center pt-3">
          <router-link to="/login">{{ $t("login") }}</router-link>
        </div>
      </b-form>
      <div v-if="successMsg" class="text-success">{{ successMsg }}</div>
    </b-container>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import BaseComponent from "@/components/BaseComponent";
  import * as userService from "@/service/userService";
  import environment from "@/environment";

  @Component
  export default class ForgotPassword extends BaseComponent {

    // username = "";
    email = "";
    errorMsg = null;
    successMsg = null;

    isLoading = false;


    mounted() {

    }

    async onSubmit() {
      // console.log(`Hit submit, username: ${this.username}, email: ${this.email}`);

      try {
        this.errorMsg = null;
        //this.successMsg = null;
        this.isLoading = true;
        const data = await userService.forgetPassword(this.email);
        this.successMsg = data.message;
      } catch (e) {
        this.errorMsg = e.response?.data?.code || e.code;
        console.error(e);

      } finally {
        this.isLoading = false;
      }
    }

  }
</script>
